<template>
  <div class="form-group position-relative" v-if="IsShow">
    <h5
      class="CPSForm-label"
      :class="{ floatedLabel: floatedLabel || $attrs['placeholder'] || temp_value }"
    >
      {{ labelText }}<span class="text-danger" v-if="validationRules"> *</span>
    </h5>
    <validation-provider
      name="DateTime"
      :rules="validationRules"
      v-slot="validationContext"
      :vid="ControlId ? ControlId : ''"
    >
      <datepicker
        v-model="temp_value"
        v-bind="$attrs"
        :input-class="getValidationStateClass(validationContext)"
        :clear-button="disabled === true || clearable === false ? false : true"
        calendar-button-icon="fa fa-calendar"
        :calendar-button="showDataIcon"  
        @blur="checkValue"
        :format="privateDateTimeFormat"
        :disabled="disabled"
        :typeable="typeable"
      >
      </datepicker>
      <b-form-invalid-feedback :state="getValidationState(validationContext)">
        {{ $t("lbl_EMPBE_PleaseSelect") }}
      </b-form-invalid-feedback>
    </validation-provider>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
export default {
  props: ["value", "ControlId", "isshow", "mandatory", "title", "dateTimeFormat", "disabled", "clearable", "typeable"],
  components: {
    Datepicker,
  },
  data() {
    return {
      privateDateTimeFormat: this.dateTimeFormat,
      temp_value: this.value,
      IsShow: true,
      labelText: this.title,
      mandatoryText: this.mandatory,
      validationRules: this.mandatory == null ? null : { required: true },
      floatedLabel: this.checkValue(),
      showDataIcon:true,
    };
  },
  computed: {
    ...mapGetters({
      GetPermissionJsonById: "responsePermission/getPermissionJsonById",
    }),
    record() {
      return this.GetPermissionJsonById({ ControlId: this.ControlId });
    },
  },
  watch: {
    value() {
      this.temp_value = this.value;
      if(this.temp_value) this.showDataIcon=false; else this.showDataIcon=true
    },
    temp_value(newVal, oldVal) {
      this.temp_value = newVal;
      this.inputchange();
      this.checkValue();
    },
    dateTimeFormat(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.privateDateTimeFormat = newVal;
    },
  },
  mounted() {
    if (this.value == "1900-01-01 00:00:00") {
      this.temp_value = "";
    } else {
      this.temp_value = this.value;
    }

    this.checkValue();
    //read from json
    if (this.record != null) {
      if (this.record.IsShow != null) this.IsShow = this.record.IsShow;
      if (this.record.IsMandatory) this.validationRules = { required: true };
      if (this.record.IsDisable != null) this.$attrs["disabled"] = this.record.IsDisable;
      if (this.record.Label != null) this.labelText = this.$t(this.record.Label);
    }
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getValidationStateClass({ dirty, validated, valid = null }) {
      if (this.getValidationState({ dirty, validated, valid })) {
        return "form-control is-valid";
      } else {
        return "form-control";
      }
    },
    updateValue(e) {
      this.$emit("fromChird_selectDate", this.temp_value);
      this.$emit("input", this.temp_value);
    },
    focusInput() {
      this.floatedLabel = true;
    },
    checkValue() {
      if (this.temp_value != undefined && this.temp_value.length > 0) {
        this.floatedLabel = true;
      } else {
        this.floatedLabel = false;
      }
      this.$emit("fromChird_selectDate", this.temp_value);
      this.$emit("input", this.temp_value);
    },
    inputchange() {
      var datetime = this.formatDate(this.temp_value);
      // console.log("选中的日期: ", this.temp_value);
      this.$emit("fromChird_selectDate", datetime);
      this.$emit("input", this.datetime);
    },
    formatDate(value) {
      const date = new Date(value);
      const dateFormat = "YYYY-MM-DD HH:mm:ss";
      const dateMoment = this.$moment(date).format(dateFormat).toString();
      return dateMoment;
    },
  },
};
</script>
